module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/screens/dashboard_charts-0ac78937c76e5a33dbeaa76d19f43984.png";